import "./Deal.css";
import { useNavigate } from "react-router-dom";


function Deal() {
    const navigate = useNavigate();
  return (
    <section className="deal-section d-flex align-items-center justify-content-center text-center">
      <div className="deal-content">
        <h2 className="deal-title">Special Deal of The Day</h2>
        <p className="deal-desc">
          Don’t miss out on our exclusive offer. Limited time only!
        </p>
        <button
      className="btn btn-outline-warning hero-btn"
      onClick={() => navigate("/products")} // غيّر /products لو عايز يروح مكان تاني
    >
      Shop Now
    </button>      </div>
    </section>
  );
}

export default Deal;
